import React, { useState, useEffect } from "react";
import axios from "axios";
import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";
import { getImageUrl } from "src/Common/common";
import { paymentItems } from "src/Common/contants";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { FiChevronDown } from "react-icons/fi";

const PaymentDropdown = ({ itemClicked, defaultValue }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(defaultValue);

  const itemSelected = (index) => {
    itemClicked(index);
    setSelectedIndex(index);
    setDropdownOpen(false);
  };

  useEffect(() => {
    setSelectedIndex(defaultValue);
  }, [defaultValue]);

  const displayLabel =
    typeof selectedIndex === "number" && selectedIndex >= 0 && selectedIndex < paymentItems.length
      ? paymentItems[selectedIndex]
      : "Select";

  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        setDropdownOpen(false);
      }}
    >
      <div className="w-full h-[30px] border-solid border-[1px] rounded-[6px] border-borderColor relative pr-4">
        <div
          onClick={() => {
            setDropdownOpen(!dropdownOpen);
          }}
          className="w-full h-full flex items-center justify-between cursor-pointer"
        >
          <p className="text-[12px] font-OpenSansRegular text-titleColor px-3 ">{displayLabel}</p>
          <FiChevronDown className="ml-2" size={15} />
        </div>
        {dropdownOpen && (
          <div className="w-full absolute top-[30px] border-solid border-[1px] rounded-[6px] border-borderColor bg-white">
            {paymentItems.map((item, index) => {
              const isSelected = selectedIndex === index;
              return (
                <div
                  key={index}
                  className={`h-[30px] px-[6px] cursor-pointer flex items-center transition-colors ${
                    isSelected ? "bg-gray-200" : ""
                  } hover:bg-gray-200`}
                  onClick={() => itemSelected(index)}
                >
                  <span className={`text-[12px] text-titleColor `}>{item}</span>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </OutsideClickHandler>
  );
};

export default PaymentDropdown;
